import React from "react";
import AdminHeader from "../../components/Layout/AdminHeader";
import AdminSideBar from "../../components/Admin/Layout/AdminSideBar";
import AdminVendorPayments from "../../components/Admin/AdminVendorPayments";

const AdminVendorPaymentsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader activeMenuItem={20} />
      <div className="flex pt-16 sm:pt-20">
        <div className="hidden 800px:block w-[300px] fixed left-0 top-[75px] h-[calc(100vh-70px)] z-10">
          <AdminSideBar active={9} />
        </div>
        <div className="flex-1 w-full px-2 sm:px-4 800px:ml-[290px] 800px:px-0">
          <AdminVendorPayments />
        </div>
      </div>
    </div>
  );
};

export default AdminVendorPaymentsPage;


